import axios from 'axios'
import { Url } from './constantUrl'
import getHeaders from './getHeaders'
import getHeadersformdata from './getHeaderFormdata'
import * as types from './types'
import { errorHandler } from './error/errorHandler.action'
import { notify } from '../services/notification'
import { HTTP_STATUS } from '../constants/httpsStatus/httpsStatus'

//Query_list
export const uniqueIdListAction = (page, param, fromDate, toDate) => async (dispatch) => {
  try {
    const baseUrl = `${process.env.REACT_APP_API_URL}${Url.GET_UNIQUE_ID_GENERATION}?page=${page}&page_size=10`;
    let url = baseUrl;

    if (param)      url += `&status=${param}`;
    if (fromDate)   url += `&start_date=${fromDate}`;
    if (toDate)     url += `&end_date=${toDate}`;

    const options = {
      method: 'GET',
      headers: getHeaders(),
      url: url,
    };

    const resp = await axios(options);

    if (resp.status === HTTP_STATUS.SUCCESS || resp.status === HTTP_STATUS.CREATED) {
      dispatch({ type: types.GET_UNIQUE_ID_GENERATION_LIST, payload: resp });
      return resp;
    } else {
      return null;
    }
  } catch (error) {
    errorHandler(error);
    return null;
  }
};

export const searchUniqueIdGenerationAction = (params = {}) => dispatch => {
  dispatch({ type: types.SEARCH_UNIQUE_ID_GENERATION_QUERY, payload: params ? { data: params } : null })
}

export const pageUniqueIdGenerationActionAction = (params = {}) => dispatch => {
  dispatch({ type: types.SEARCH_UNIQUE_ID_GENERATION_QUERY, payload: params ? { data: params } : null })
}
